import React from 'react'

import {
  FallbackNodeComponent,
  NodeToCompontentMapping,
} from 'common/builder/components/chart/FlowChart/constants/NodeToComponentMapping'
import { useFlowChartState } from 'common/builder/components/chart/FlowChart/contexts/FlowChartStateContext'

import { PixiObjectProps } from './interfaces/PixiObjectProps'
import { DEFAULT_NODE_WIDTH } from './nodes/shared/config'
import { PixiObjectNodeWrapper } from './PixiObjectNodeWrapper'
import { FlowChartNode } from './types/FlowChartNode/FlowChartNode'

export const Node = (props: PixiObjectProps<FlowChartNode>) => {
  const flowChartState = useFlowChartState()

  const Component = NodeToCompontentMapping[props.node.type] || FallbackNodeComponent

  return (
    <PixiObjectNodeWrapper
      {...props}
      component={Component}
      pixiWidth={DEFAULT_NODE_WIDTH}
      flowChartState={flowChartState}
    />
  )
}
